import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthComponent } from './auth.component';
import { LoginCollaboratorComponent } from './components/login-collaborator/login-collaborator';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';

const routes: Routes = [
  {
    path: 'auth', // Base path para "auth"
    component: AuthComponent,
    children: [
      {
        path: 'login', // Ruta para "auth/login"
        component: LoginCollaboratorComponent,
        data: { returnUrl: window.location.pathname },
      },
      {
        path: 'reset-password',
        component: ForgotPasswordComponent,
      },
      {
        path: 'forgot-password/:random',
        component: ResetPasswordComponent,
      },
      {
        path: '**', // Redirige cualquier ruta inválida bajo "auth"
        redirectTo: 'login',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
